<template>
  <draggable tag="div" :list="rules" :group="{ name: 'rules' }" class="item-container" @start="isDragging = true" @end="isDragging = false" v-bind="dragOptions">
    <div v-for="item in rules" :key="item.id" class="item-group">
      <table class="table item"><tbody>
        <td><v-select label="Parameter" :items="parameters" v-model="item.parameter"></v-select></td>
        <td><v-select label="Rule" :items="operators" v-model="item.operator"></v-select></td>
        <td>
          <v-select label="Value" v-if="item.parameter === 'Type'" :items="types" v-model="item.value"></v-select>
          <v-text-field label="Value" v-else v-model="item.value" />
        </td>
        <td><v-select label="Action" :items="actions" v-model="item.action"></v-select></td>
        <td><v-btn icon @click="remove(item.id)"><v-icon color="#cc3333">mdi-minus</v-icon></v-btn></td>
      </tbody></table>
      <filtering-rules-tree class="item-sub" :rules="item.rules" :types="types" :parameters="parameters" :operators="operators" :actions="actions" />
    </div>
  </draggable>
</template>
<script>
import draggable from "vuedraggable";

export default {
  props: {
    rules: {
      required: true,
      type: Array
    },
    types: {
      type: Array,
      required: true
    },
    parameters: {
      type: Array,
      required: true
    },
    operators: {
      type: Array,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
  },
  components: {
    draggable
  },
  name: "filtering-rules-tree",
  methods: {
    remove(id) {
      const pos = this.rules.findIndex(e => { return e.id === id });
      this.rules.splice(pos, 1);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        fallbackOnBody: true,
        swapThreshold: 0.45,
        group: "rules",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
};
</script>

<style scoped>
.item-container {
  margin: 0;
}
.item {
  padding: 1rem;
  border-left: solid black 1px;
  border-bottom: solid black 1px;
  background-color: #fefefe;
}
.item-sub {
  margin: 0 0 0 1rem;
}
</style>